<template>
    <div>
        <b-container>

            <!-- Add inventory Error -->
            <b-row>
                <b-col>
                    <b-modal no-fade size="l" id="modal-adderror" title="Found some errors" 
                    ok-title="OK" ok-only>
                            <template v-slot:default="{ hide }">
                                <div v-if="invalidName">Please check beer name</div>
                                <div v-if="invalidBrewer">Please check brewery name</div>
                                <div v-if="invalidType">Please check beer style</div>
                                <div v-if="invalidABV">Please check beer ABV</div>
                                <div v-if="invalidDelivery">Please choose a delivery method</div>
                                <div v-if="invalidSize">Please enter at least one container</div>
                                <div v-if="invalidBarrel1Size">Please check Barrel1 size</div>
                                <div v-if="invalidBarrel2Size">Please check Barrel2 size</div>
                                <div v-if="invalidBottleSize">Please check Can size</div>
                                <div v-if="invalidCanSize">Please check Bottle size</div>
                                <div v-if="invalidCost">Please enter only numbers for cost</div>

                            </template>
                    </b-modal>
                </b-col>
            </b-row>

        <!--       INVENTORY     -->
        <!--
        <b-row v-if="this.userProfile.isbrewer==1">
            <b-col>
                <b-button class="m-md-2"  variant="warning" v-b-modal.showBeersList  v-b-tooltip.hover.right title="Prefill from existing beers">Pre Fill From Existing Beers</b-button>
                    <b-modal no-fade  scrollable size="l" id= "showBeersList" title="Your Beers" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                        <div v-for="beer in existingBeerList" :key="beer.id">
                            <hr>
                            <a @click="selectBeer(beer)"><h6>{{beer.beerName}}</h6></a>
                        </div>
                                
                    </b-modal>
            </b-col>
        </b-row>
        -->

        <b-row>
            <b-col>
                <b-container class='inventorycard' style="margin-top:10px; margin-bottom:20px">
                    <!--       DISTRIBUTOR  BREWERY   -->
                    <b-row  v-if="userProfile.isbrewer==2" style="margin-top:10px">
                        <b-col>
                            <div v-if='invalidBrewer' class='inputwarning'>Please choose brewery</div>
                            <b-dropdown style="margin-top:10px"  variant="primary"  size="lg"  id="dropbowndelselect" text="Select A Brewery">
                                <b-dropdown-item  v-for="(brewery) in distributorBreweries" :key="brewery.company" @click="setBrewery(brewery)">{{brewery.company}}</b-dropdown-item>
                            </b-dropdown>
                        </b-col>
                    </b-row>
                    <b-row  v-if="userProfile.isbrewer==2" >
                        <b-col><strong>{{beer.brewerName}}</strong></b-col>
                    </b-row>

                        <!--       END OF DISTRIBUTOR     -->


                    <b-row>
                        <b-col>
                            <form>
                                <div style="margin-top:10px">
                                    <label for="beerName" size="sm">Name</label>
                                    <div v-if='invalidName' class='inputwarning'>Please check name</div>
                                    <input v-model="beer.beerName" type="text" placeholder="Awesome IPA" id="beerName" />
                                </div>
                            </form>
                        </b-col>
                    </b-row>
                    <!-- New Size Inputs -->
                    <b-row v-if="invalidSize" class='inputwarning'>
                        <b-col>
                            Please check valid sizes are entered
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div  style="text-align:center">
                                <img width="40px" src="../assets/barrel.png"/>

                                <b-form-group  label="Barrel 1">
                                    <b-form-group
                                        label-cols-sm="3" 
                                        label-size="sm"
                                        label="Size"
                                        label-align-sm="right"
                                        label-for="nested-barrelsize1"
                                    >                                          
                                        <b-form-select id='nested-barrelsize1' v-model="beer.barrel1Size" :options="barrelSizeOptions">
                                            <template v-slot:first>
                                                <!-- This is required to prevent bugs with Safari -->
                                                <option disabled value="">Choose barrel1 size</option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                                
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Cost($)"
                                        label-align-sm="right"
                                        label-for="nested-barrel1cost"
                                    >
                                        <b-form-input  size="sm" v-model="beer.barrel1Cost" id="nested-barrel1cost"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Quantity"
                                        label-align-sm="right"
                                        label-for="nested-barrel1quantity"
                                    >
                                        <b-form-input  size="sm" v-model="beer.barrel1Quantity" id="nested-barrel1quantity"></b-form-input>
                                    </b-form-group>

                                </b-form-group>

                                <b-form-group  label="Barrel 2">
                                    <b-form-group
                                        label-cols-sm="3" 
                                        label-size="sm"
                                        label="Size"
                                        label-align-sm="right"
                                        label-for="nested-barrelsize2"
                                    >                                          
                                        <b-form-select id='nested-barrelsize2' v-model="beer.barrel2Size" :options="barrelSizeOptions">
                                            <template v-slot:first>
                                                <!-- This is required to prevent bugs with Safari -->
                                                <option disabled value="">Choose barrel2 size</option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                                
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Cost($)"
                                        label-align-sm="right"
                                        label-for="nested-barrel2cost"
                                    >
                                        <b-form-input  size="sm" v-model="beer.barrel2Cost" id="nested-barrel2cost"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Quantity"
                                        label-align-sm="right"
                                        label-for="nested-barrel2quantity"
                                    >
                                        <b-form-input  size="sm" v-model="beer.barrel2Quantity" id="nested-barrel2quantity"></b-form-input>
                                    </b-form-group>

                                </b-form-group>


                            </div>
                        </b-col>
                        <b-col>
                            <div  style="text-align:center">
                                <img width="40px" src="../assets/can2.png"/>
                                <b-form-group  label="Cans">
                                    <b-form-group
                                        label-cols-sm="3" 
                                        label-size="sm"
                                        label="Oz/Can:"
                                        label-align-sm="right"
                                        label-for="nested-street1"
                                    >
                                        
                                        <b-form-input  size="sm" v-model="beer.ozPerCan"  type="number" id="nested-street1"></b-form-input>
                                    </b-form-group>
                                                
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Case Size"
                                        label-align-sm="right"
                                        label-for="nested-street2"
                                    >
                                        <b-form-input  size="sm" v-model="beer.cansPerCase" id="nested-street2"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Cost($)"
                                        label-align-sm="right"
                                        label-for="nested-cancost"
                                    >
                                        <b-form-input  size="sm" v-model="beer.canCost" id="nested-cancost"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Quantity"
                                        label-align-sm="right"
                                        label-for="nested-canquantity"
                                    >
                                        <b-form-input  size="sm" v-model="beer.canQuantity" id="nested-canquantity"></b-form-input>
                                    </b-form-group>


                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col>
                            <div  style="text-align:center">
                                <img width="40px" src="../assets/bottle.png"/>
                                <b-form-group label="Bottles">
                                    <b-form-group
                                        label-cols-sm="3" 
                                        label-size="sm"
                                        label="Oz/Bottle:"
                                        label-align-sm="right"
                                        label-for="nested-street"
                                    >
                                        
                                        <b-form-input  size="sm" v-model="beer.ozPerBottle"  type="number" id="nested-street"></b-form-input>
                                    </b-form-group>
                                                
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Case Size"
                                        label-align-sm="right"
                                        label-for="nested-street"
                                    >
                                        <b-form-input  size="sm"  v-model="beer.bottlesPerCase" type='number' id="nested-street"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Cost($)"
                                        label-align-sm="right"
                                        label-for="nested-bottlecost"
                                    >
                                        <b-form-input  size="sm" v-model="beer.bottleCost" id="nested-bottlecost"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label-cols-sm="3"
                                        label-size="sm"
                                        label="Quantity"
                                        label-align-sm="right"
                                        label-for="nested-bottlequantity"
                                    >
                                        <b-form-input  size="sm" v-model="beer.bottleQuantity" id="nested-bottlequantity"></b-form-input>
                                    </b-form-group>


                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>
                    <!-- End Of New Size Inputs -->

                    <b-row>
                        <div v-if='invalidType' class='inputwarning'>Please select a beer style</div>
                    </b-row>

                    <b-row>
                        <b-col>
                            <!-- Select beer style dropdown -->
                            <b-dropdown variant='light' id="dropbownbeerselect" text="Select A Beer Style">
                                <b-dropdown-item  v-for="(mainStyle) in mainBeerStyles" :key="mainStyle" @click="setOtherStyle(mainStyle)">{{mainStyle}}</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <!-- More styles button -->
                                <b-dropdown-item-button  variant="info" v-b-modal.modalmorestyles >More Styles</b-dropdown-item-button>
                            </b-dropdown>

                        </b-col>
                    </b-row>
                    <!-- Show the selected beer style -->
                    <b-row>
                        <b-col><strong>{{beer.type}}</strong></b-col>
                    </b-row>

                    <!-- Modal to select more styles -->
                    <b-modal no-fade  scrollable size="xl" id= "modalmorestyles" title="More Styles" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                    <div v-if='invalidType' class='inputwarning'>Please enter beer type</div>
                    <div v-for="(category) in getFullBeersList" :key="category.group">
                        <h5>{{category.group}}</h5>
                        <div v-for="(beer) in category.beers" :key="beer" style="cursor: pointer;"  @click="setOtherStyle(beer)">
                            {{beer}}
                        </div>
                        <hr>
                    </div>
                    <div style="cursor: pointer;"  @click="setOtherStyle('Other')">
                        <div v-if='invalidType' class='inputwarning'>Please enter beer type</div>
                        <h5>Other</h5>
                    </div>
                    <hr>    
                    </b-modal>

                    
                    <b-row>
                        <b-col>
                            <form style="width:400px" v-if="!(beer.type=='Other')">
                                <hr>
                                <label for="thesubtype">(Optional) Sub Style</label>
                                <input v-model="beer.subType" type="thesubtype" id="customtype"  placeholder="Ex: Hazy, Dubbel"/>
                                <hr>
                            </form>
                            
                        </b-col>

                        
                    </b-row>
                    <!-- Custom Style -->
                    <b-row></b-row>
                    <div  v-if="beer.type=='Other'">
                        <b-col>
                            <form>
                                <div v-if='invalidType' class='inputwarning'>Please enter beer type</div>
                                <label for="customtype">Enter a custom style name</label>
                                <input v-model="beer.customType" type="text" id="customtype"/>
                            </form>
                        </b-col>
                    </div>
                    <b-row>
                        <b-col>
                            <div v-if="beer.type=='Other'" class="mt-3" style="margin-bottom: 20px">Display Name: <h5>{{ beer.customType }}</h5></div>
                            <div v-else class="mt-3" style="margin-bottom: 20px">Display Style: <h5>{{ beer.type }}, {{beer.subType}}</h5>
                            </div>
                        </b-col>
                    </b-row>


                        <b-row v-if="userProfile.isbrewer==1" style="margin-top:10px">
                            <b-col>
                                <div v-if='invalidDelivery' class='inputwarning'>Please choose delivery method</div>
                                <b-dropdown variant='light' id="dropbowndelselect" text="Select A Distribution Method">
                                    <b-dropdown-item  v-for="(deliveryAgent) in getDeliveryAgents" :key="deliveryAgent" @click="beer.deliveryMethod=deliveryAgent">{{deliveryAgent}}</b-dropdown-item>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-dropdown-item-button  v-b-modal.modalmoremethods >Other</b-dropdown-item-button>
                                </b-dropdown>
                                    <b-modal no-fade id= "modalmoremethods"  title="Other delivery method" ok-only ok-title="OK"  @ok="beer.deliveryMethod=otherDeliveryMethod">
                                    <b-form-group
                                        class="mb-0"
                                        label-for="textarea-formatter-delivery"
                                        
                                    >
                                    <b-form-textarea
                                        id="textarea-formatter-delivery"
                                        v-model="otherDeliveryMethod"                    
                                    ></b-form-textarea>
                                </b-form-group>
                                                    
                                </b-modal>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col><strong>{{theDeliveryMethod}}</strong></b-col>
                        </b-row>


                    <b-row>

                        <b-col>
                            <form>
                                <label for="abv">ABV(%)</label>
                                <div v-if='invalidABV' class='inputwarning'>Please enter ABV</div>
                                <input v-model="beer.abv" type="text" placeholder="5" id="abv" />
                            </form>
                        </b-col>
                        <b-col>

                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <form>
                                <label for="description">Description</label>
                                <textarea v-model.trim="beer.description" id="description" placeholder="Description"> </textarea>
                            </form>

                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <div style="margin-top:20px; margin-bottom:20px">
                                <div v-if="showAddBeerError" class='inputwarning'> Please correct the errors above</div>
                                <b-button  size="lg" @click="addbeer" class="btn btn-success">Add This Beer</b-button>

                                <transition name="fade">
                                <p v-if="showSuccess" class="success">Beer added</p>
                                </transition>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>

        <!-- End Add Inventory -->

        </b-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    import { currentUser } from '../firebaseConfig'
    const fb = require('../firebaseConfig.js')
    import {htmldatetounix} from './Myfunctions'
    import {fullBeerStylesList} from './Myfunctions'
    import { deliveryAgents } from './Myfunctions'
    import {mainBeerStylesList} from './Myfunctions'

    export default {
        props: ['existingBeerList'],
        computed: {
            ...mapState(['userProfile', 'currentUser','userInventory', 'promotionsEnabled', 'distributorBreweries']),
            getFullBeersList(){
                var beersList = fullBeerStylesList()
                return beersList
            },
            getDeliveryAgents(){
                var deliveryList = deliveryAgents
                return deliveryList
            },
            theDeliveryMethod(){
                if(this.beer.deliveryMethod) return this.beer.deliveryMethod
                else if(this.userProfile.isbrewer&&this.userProfile.deliveryMethod){
                    this.beer.deliveryMethod = this.userProfile.deliveryMethod
                    return this.userProfile.deliveryMethod
                }
                else return ""
            },
            mainBeerStyles(){  
                return mainBeerStylesList
            },

        },

        data() {
            return {
                beer:{
                    beerName:'',
                    quantity:'',
                    abv:'',
                    type:null,
                    description:'',
                    cost:'',
                    availableDate:'',
                    size:'',
                    container:'',
                    barrel1Size:'',
                    barrel1Quantity:'',
                    barrel1Cost:'',
                    barrel2Size:'',
                    barrel2Quantity:'',
                    barrel2Cost:'',
                    cansPerCase:'',
                    canQuantity:'',
                    ozPerCan:'',
                    ozPerBottle:'',
                    bottlesPerCase:'',
                    bottleQuantity:'',
                    subType:'',
                    customType:null,
                    deliveryMethod:'',  
                    brewerName:'',
                    brewerId:'',
                    logoFileThumbnailURL:'',
                    selectedDistroBrewer:{},
                    
                    canCost:'',
                    bottleCost:'',
                    multiSize:1,
                    
                },  
                otherDeliveryMethod:'',
                containerOptions: [
                    { text: 'Keg', value: 'keg' },
                    { text: 'Can', value: 'cans' },
                    { text: 'Bottle', value: 'bottles' }
                ],
                typeOptions: [
                    { text: 'Amber Ale', value:'Amber Ale'},
                    { text: 'Belgian', value:'Belgian'},
                    { text: 'Blonde', value: 'Blonde' },
                    { text: 'Brown Ale', value:'Brown Ale'},
                    { text: 'Golden Ale', value: 'Golden Ale' },
                    { text: 'Hefeweizen', value:'Hefeweizen'},
                    { text: 'IPA', value: 'IPA' },
                    { text: 'Lager', value: 'Lager' },
                    { text: 'Pale Ale', value: 'Pale Ale' },
                    { text: 'Pilsner', value: 'Pilsner' },
                    { text: 'Porter', value: 'Porter' },
                    { text: 'Red Ale', value:'Red Ale'},
                    { text: 'Saison', value: 'Saison' },
                    { text: 'Stout', value: 'Stout' },
                    { text: 'Wheat', value:'Wheat'},
                    { text: 'Other', value: 'Other' },

                ],

                showSuccess: false,
                showDateWarning: false,
                updatingItem: false,
                barrelSizeOptions: [
                    { value: '1/2 Barrel, 15.5 Gal', text: '1/2 Barrel, 15.5 Gal'},
                    { value: '13.2 Gal, 50L', text: '13.2 Gal, 50L'},
                    { value: '1/4th Barrel, 7.75 Gal', text: '1/4th Barrel, 7.75 Gal'},
                    { value: '1/6th Barrel 5.16 Gal', text: '1/6th Barrel, 5.16 Gal'},
                    ],

                    maxDescriptionLength:400,
                    invalidName:false,
                    invalidBrewer: false,
                    invalidQuantity:false,
                    invalidSize:false,
                    invalidType:false,
                    invalidCost:false,
                    invalidABV:false,
                    invalidDate:false,
                    showAddBeerError:false,
                    invalidContainer:false,
                    invalidDelivery:false,
                    invalidBarrel1Size : false,
                    invalidBarrel2Size : false,
                    invalidBottleSize : false,
                    invalidCanSize : false,

            }
            },

        methods: {

            setDeliveryMethod(theMethod){
                this.beer.deliveryMethod=theMethod

            },
            setOtherDeliveryMethod(){
                this.beer.deliveryMethod = this.otherDeliveryMethod
            },
            setBrewery(brewery){
                this.selectedDistroBrewer = brewery
                this.beer.brewerName = brewery.company
                this.beer.brewerId = brewery.distbrewerid
                if (brewery.logoFileThumbnailURL) this.beer.logoFileThumbnailURL = brewery.logoFileThumbnailURL
                else this.beer.logoFileThumbnailURL = ''
            },

            userClickedModalErrorOK(){

            },

            addbeer() {
                var beerToAdd = {}
                //Set multi size always = 1
                beerToAdd.multiSize = 1

                var min=11111111111111111; 
                var max=99999999999999999;  
                this.invalidName=false
                this.invalidQuantity=false

                this.invalidSize=true

                this.invalidType=false
                this.invalidCost=false
                this.invalidABV=false
                this.showAddBeerError=false
                this.invalidContainer = false
                var perCase = ''
                var size = ''
                var units=''

                //Check for errors everywhere
                //Beer name
                if(!this.beer.beerName) this.invalidName = true
                else this.invalidName = false

                //Distributor brewery
                if(!this.beer.brewerName&&this.userProfile.isbrewer==2) this.invalidBrewer = true
                else this.invalidBrewer = false

                //Check beer style
                var finalBeerType
                if (this.beer.type=='Other'){
                    finalBeerType = this.beer.customType
                }
                else finalBeerType = this.beer.type

                if(!finalBeerType) this.invalidType = true
                else this.invalidType = false

                //Check ABV
                this.beer.abv = parseFloat(this.beer.abv)
                if((this.beer.abv<0)||isNaN(this.beer.abv)) {
                    this.invalidABV = true
                    this.beer.abv=''

                } 
                else this.invalidABV = false
                
                //Check beer sizes and that at least one has been entered
                var hasBarrels1 = 0
                var hasBarrels2 = 0
                var hasCans = 0
                var hasBottles = 0
                //CHECK IF ALL FIELDS HAVE BEEN ENTERED FOR A CONTAINER
                if (this.beer.barrel1Size||this.beer.barrel1Cost||this.beer.barrel1Quantity){
                    if(!this.beer.barrel1Size||!this.beer.barrel1Cost||this.beer.barrel1Quantity<1||isNaN(this.beer.barrel1Quantity)) this.invalidBarrel1Size = true
                    else {
                        this.invalidBarrel1Size = false
                        hasBarrels1 = 1
                        beerToAdd.barrel1Size = this.beer.barrel1Size
                        if(isNaN(this.beer.barrel1Cost)) this.invalidCost=true
                        beerToAdd.barrel1Cost = this.beer.barrel1Cost
                        beerToAdd.barrel1Quantity = parseInt(this.beer.barrel1Quantity)
                    }
                } 
                if (this.beer.barrel2Size||this.beer.barrel2Cost||this.beer.barrel2Quantity){
                    if(!this.beer.barrel2Size||!this.beer.barrel2Cost||this.beer.barrel2Quantity<1||isNaN(this.beer.barrel2Quantity)) this.invalidBarrel2Size = true
                    else{
                        this.invalidBarrel2Size = false
                        hasBarrels2 = 1                        
                        beerToAdd.barrel2Size = this.beer.barrel2Size
                        if(isNaN(this.beer.barrel2Cost)) this.invalidCost=true
                        beerToAdd.barrel2Cost = this.beer.barrel2Cost
                        beerToAdd.barrel2Quantity = parseInt(this.beer.barrel2Quantity)
                    }                   
                } 
                if (this.beer.ozPerCan||this.beer.canCost||this.beer.cansPerCase||this.beer.canQuantity){
                    if (!this.beer.ozPerCan||!this.beer.canCost||!this.beer.cansPerCase||this.beer.canQuantity<1||isNaN(this.beer.canQuantity)) this.invalidCanSize = true
                    else{
                        this.invalidCanSize  = false
                        hasCans = 1
                        beerToAdd.ozPerCan = this.beer.ozPerCan
                        if(isNaN(this.beer.canCost)) this.invalidCost=true
                        beerToAdd.canCost = this.beer.canCost
                        beerToAdd.cansPerCase = this.beer.cansPerCase
                        beerToAdd.canQuantity = parseInt(this.beer.canQuantity)
                    }                   
                } 
                if(this.beer.ozPerBottle||this.beer.bottleCost||this.beer.bottlesPerCase||this.beer.bottleQuantity){
                    if(!this.beer.ozPerBottle||!this.beer.bottleCost||!this.beer.bottlesPerCase||this.beer.bottleQuantity<1||isNaN(this.beer.bottleQuantity)) this.invalidBottleSize = true
                    else{
                        this.invalidBottleSize  = false
                        hasBottles = 1
                        beerToAdd.ozPerBottle = this.beer.ozPerBottle
                        if(isNaN(this.beer.bottleCost)) this.invalidCost=true
                        beerToAdd.bottleCost = this.beer.bottleCost
                        beerToAdd.bottlesPerCase = this.beer.bottlesPerCase
                        beerToAdd.bottleQuantity = parseInt(this.beer.bottleQuantity)
                    }    
                }
                //Check of any of the sizes were entered incorrectly
                if(this.invalidBarrel1Size||this.invalidBarrel2Size||this.invalidBottleSize||this.invalidCanSize) this.invalidSize = true
                else this.invalidSize = false
                //Check if at least one container was entered
                if(!hasBarrels1&&!hasBarrels2&&!hasCans&&!hasBottles) this.invalidSize = true
                else this.invalidSize = false
                //End of new sizes

                //Check delivery method
                var thedeliveryMethod = ''
                //Distribution method = self for distributors
                if (this.userProfile.isbrewer==1){
                    thedeliveryMethod = this.beer.deliveryMethod
                } 
                if (this.userProfile.isbrewer==2){
                    thedeliveryMethod = this.userProfile.company

                } 
                if(!thedeliveryMethod) this.invalidDelivery = true
                else this.invalidDelivery = false

                //Check all errors
                if(this.invalidDelivery||this.invalidName||this.invalidSize||
                this.invalidType||this.invalidABV||this.invalidBrewer||this.invalidCost){
                    this.showAddBeerError = true
                    this.$bvModal.show("modal-adderror")
                    return
                } 
                else this.showAddBeerError = false    


                beerToAdd.type = finalBeerType
                beerToAdd.subType = this.beer.subType
                beerToAdd.abv=this.beer.abv
                beerToAdd.description= this.beer.description
                beerToAdd.cat= "Beers"

                //Different collections for distributors and breweries
                var brewerName = ''
                var brewerId = ''
                var distributorName=''
                var distributorId=''
                var fbref = fb.beersCollection
                

                //BrewerId is always the seller, whethere it's a distributor or brewer
                //distbrewerid tells if this beer is by a distributor. Then distbrewerid is id in distributorbrewers
                if (this.userProfile.isbrewer==1){
                    brewerName = this.userProfile.company
                    //For breweries, beer logo comes from userProfile
                    if(this.userProfile.logoFileThumbnailURL) beerToAdd.logoFileThumbnailURL = this.userProfile.logoFileThumbnailURL
                    else beerToAdd.logoFileThumbnailURL = ""
                } 
                if (this.userProfile.isbrewer==2){
                    brewerName = this.selectedDistroBrewer.company
                    beerToAdd.distbrewerid=this.selectedDistroBrewer.distbrewerid
                    beerToAdd.logoFileThumbnailURL=this.selectedDistroBrewer.logoFileThumbnailURL
                    distributorName = this.userProfile.company
                    distributorId = this.currentUser.uid
                } 
                

                //var date = new Date(Date.UTC(this.beer.availableDate));
                //var startDate = date.getTime();
                var createdDate = new Date()
                var createdTime = createdDate.getTime()
                beerToAdd.createdOn = createdDate
                beerToAdd.createdTime = createdTime

                beerToAdd.distributorName = distributorName
                beerToAdd.distributorId = distributorId
                beerToAdd.beerName = this.beer.beerName
                beerToAdd.uid = this.currentUser.uid
                
                //If rep, use distributorid for uid
                if(this.userProfile.isbrewer==10) beerToAdd.uid=this.userProfile.distributorid

                beerToAdd.deliveryMethod = thedeliveryMethod
                beerToAdd.ordersCount = 0
                beerToAdd.brewer = brewerName

                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                beerToAdd.id = randomIdString

                beerToAdd.counties = this.userProfile.counties
                beerToAdd.state = this.userProfile.state
                
                fbref.add(beerToAdd).then(() => {
                        this.showSuccess = true
                        this.$bvToast.toast(this.beer.beerName + ' Added to inventory', {
                        title: 'Beer Added!',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                        setTimeout(() => { this.showSuccess = false }, 2000)
                        this.beer.beerName = ''
                        this.beer.quantity = ''
                        this.beer.abv = ''
                        this.beer.type = ''
                        this.beer.customType = ''
                        this.beer.description = ''
                        this.beer.cost=''
                        this.beer.subType=''
                        this.beer.barrel1Size=''
                        this.beer.barrel1Quantity=''
                        this.beer.barrel1Cost=''
                        this.beer.barrel2Size=''
                        this.beer.barrel2Quantity=''
                        this.beer.barrel2Cost=''
                        this.beer.cansPerCase=''
                        this.beer.canQuantity=''
                        this.beer.ozPerCan=''
                        this.beer.ozPerBottle=''
                        this.beer.bottlesPerCase=''
                        this.beer.bottleQuantity=''
                        this.beer.canCost = ''
                        this.beer.bottleCost = ''

                })

            },
            selectBeer(existingBeer){
                this.$root.$emit('bv::hide::modal',"showBeersList")
                this.beer.beerName = existingBeer.beerName

                if(existingBeer.deliveryMethod) this.beer.deliveryMethod = existingBeer.deliveryMethod

                const typeIndex = this.typeOptions.findIndex(item => item.value === existingBeer.type);
                if (typeIndex !== -1) this.beer.type = existingBeer.type
                else{
                    
                    this.beer.customType = existingBeer.type
                    this.beer.type ="Other"
                    console.log("custom type = " + this.customType)
                } 

                this.beer.abv = existingBeer.abv
                this.beer.description = existingBeer.description
                if(existingBeer.subType)
                    this.beer.subType = existingBeer.subType

            },

            clickedSelectType(selectedBeerType){
                this.$root.$emit('bv::hide::modal',"modalmorestyles")

            },

            setOtherStyle(beerStyle){
                this.beer.type = beerStyle
                this.$root.$emit('bv::hide::modal',"modalmorestyles")
            }
            

            }
        
    }
</script>